// eslint-disable-next-line import/no-extraneous-dependencies
import {
  ChargesBy, gstType, invoiceStatusList, deliveryType, orderType,
  invoiceStatus,
} from 'pando-constants';
import chargesHeaders from '../constants/IndentCharges';

export const getConsigneeLists = payment =>
  payment.consignee_data && payment.consignee_data.map(consignee => Object.assign({},
    {
      name: consignee.name,
      city: consignee.city,
      address: consignee.address,
      state: consignee.state,
      pincode: consignee.pincode,
      display_reference_name: consignee.display_reference_name
    }));

export const getRoute = (payment, depots) => {
  let destination = '';
  let multidropCities = '';
  const consigneeList = getConsigneeLists(payment);
  if (consigneeList && consigneeList.length > 0) {
    if (consigneeList.length > 1) {
      destination = 'Multidrop';
      multidropCities = Object.values(consigneeList).map(consignee => (consignee.display_reference_name || consignee.city)).join(', ');
    } else {
      destination = consigneeList[0].display_reference_name || consigneeList[0].city;
    }
  }
  return { source: getDepotCity(depots, payment.depot_id), destination, multidropCities };
};

export const getRouteNames = (payment, depots) => {
  let destination = '';
  let multidropCities = '';
  const consigneeList = getConsigneeLists(payment);
  if (consigneeList && consigneeList.length > 0) {
    if (consigneeList.length > 1) {
      destination = 'Multidrop';
      multidropCities = Object.values(consigneeList).map(consignee => consignee.name).join(', ');
    } else {
      destination = consigneeList[0].name;
    }
  }
  const currentDepot = getDepot(depots, payment.depot_id);
  return { source: (currentDepot && currentDepot.name) || '', destination, multidropCities };
};

export const getRouteByDepot = (payment) => {
  let destination = '';
  let multidropCities = '';
  const consigneeList = getConsigneeLists(payment);
  if (consigneeList && consigneeList.length > 0) {
    if (consigneeList.length > 1) {
      destination = 'Multidrop';
      multidropCities = Object.values(consigneeList).map(consignee => (consignee.display_reference_name || consignee.city)).join(', ');
    } else {
      destination = consigneeList[0].display_reference_name || consigneeList[0].city;
    }
  }
  const source = payment.depot ? (payment.depot.display_reference_name || payment.depot.city) : '';
  return { source, destination, multidropCities };
};

export const getRouteAddress = (payment, depots) => {
  let destination = '';
  let source = '';
  const consigneeList = getConsigneeLists(payment);
  if (consigneeList && consigneeList.length > 0) {
    destination = consigneeList;
  }
  source = depots.find(depot => depot.id === payment.depot_id);
  return { source, destination };
};

export const getDepotCity = (depots, depotId) => {
  const currentDepot = getDepot(depots, depotId);
  return currentDepot ? (currentDepot.display_reference_name || currentDepot.city) : '';
};

export const getDepot = (depots, depotId) => depots.find(depot => depot.id === depotId);


export const getMaterialDetails = (indent) => {
  const weight = indent.consumed_capacity && indent.consumed_capacity.weight;
  const volume = indent.consumed_capacity && indent.consumed_capacity.volume;
  return { weight, volume };
};

export const getSystemCharges = charges => charges
  && charges.find(charge => charge.charges_by === ChargesBy.SYSTEM);

export const getTransporterCharges = charges => charges
  && charges.find(charge => charge.charges_by === ChargesBy.TRANSPORTER);

export const getShipperCharges = charges => charges
  && charges.find(charge => charge.charges_by === ChargesBy.SHIPPER);

export const getSum = obj => Object.values(obj).reduce((acc, val) => acc + val, 0);

export const getDummyObj = (key, value) => {
  const obj = {};
  obj[key] = value;
  return obj;
};

export const getStatusById = id => invoiceStatusList.find(i => i.id === id);
export const getStatusByName = name => invoiceStatusList.find(i => i.name === name);
export const getStatus = (statusList, id) => statusList.find(i => i.id === id);

export const getStatusClass = (statusList, id, isRejected = false) => {
  const status = (id === invoiceStatus.CUSTOM) ? {
    color: isRejected ? 'scarlet' : 'midnightexpress',
  } : getStatus(statusList, id);
  return status && `color-${status.color.toLowerCase()}`;
};

// Reverse 'Yes' else 'No'.
export const isTaxReverseChargePayable = gst => (gst === gstType.RCM ? 'Yes' : 'No');

export const isPTLIndentType = indentDeliveryType =>
  indentDeliveryType && indentDeliveryType === deliveryType.PTL;

export const isFTLIndentType = indentDeliveryType =>
  indentDeliveryType && indentDeliveryType === deliveryType.FTL;

export const isOpenOrder = indentType =>
  indentType && indentType === orderType.OPEN;

export const isChangedTruckType = indent => (indent.transporter_truck_type ?
  (indent.transporter_truck_type !== indent.truck_type) : false);

export const hasTransporterEditedCharges = (charges) => {
  if (!charges || charges.length < 2) return false;
  const systemCharges = charges.find(charge => charge.charges_by === ChargesBy.SYSTEM);
  const transporterCharges = charges.find(charge => charge.charges_by === ChargesBy.TRANSPORTER);
  if (!systemCharges || !transporterCharges) return false;

  const hasEditableChanges = chargesHeaders.some(header => {

    const field = header.column;
    const systemValue = systemCharges[field];
    const transporterValue = transporterCharges[field];
    return (systemValue || 0) !== (transporterValue || 0);
  });

  const hasCustomChanges = Object.keys(systemCharges).some(field => {
    if (!field.startsWith('custom_')) return false;
    const systemValue = systemCharges[field];
    const transporterValue = transporterCharges[field];
    return (systemValue || 0) !== (transporterValue || 0);
  });

  return hasEditableChanges || hasCustomChanges;
};


export const isChangedSystemCharges = (charges, applicableCharges) => {
  let isChanged = false;
  if (charges) {
    const transporterCharges = charges.find(charge => charge.charges_by === ChargesBy.TRANSPORTER);
    const systemCharges = charges.find(charge => charge.charges_by === ChargesBy.SYSTEM);
    applicableCharges.forEach((charge) => {
      if ((systemCharges[charge] || 0) !== (transporterCharges[charge] || 0)) {
        isChanged = true;
      }
    });
    return isChanged;
  }
};

export const isInvoiceSignatureEnabled = currentClient =>
  currentClient && currentClient.payment_settings &&
  currentClient.payment_settings.invoice_signature_verification;
